// Copyright (c) Docugami, Inc. All rights reserved.

import { OAuthModal } from "components/authentication/OAuthModal";
import { IconDescriptor } from "components/work_path/IconRenderer";
import { OAuthRequestStatus } from "networking/Authentication";
import { ProviderId } from "networking/StorageProviders";
import { useMemo } from "react";
import { getIconDescriptorForStorageProvider, getProviderFriendlyName } from "storage/StorageProviderHelpers";

interface StorageProviderAuthenticationModalProps {
    providerId: ProviderId;
    status: OAuthRequestStatus;
    onDismiss: () => void;
    onCancel: () => void;
    autoDismiss?: boolean;
}

export const StorageProviderAuthenticationModal = (props: StorageProviderAuthenticationModalProps): JSX.Element => {
    const icon = useMemo((): IconDescriptor => {
        return getIconDescriptorForStorageProvider(props.providerId);
    }, [props.providerId]);

    const title = `Connecting to ${getProviderFriendlyName(props.providerId)}`;

    return (
        <OAuthModal
            icon={icon}
            title={title}
            {...props} />
    )
}
